module.exports = __webpack_public_path__ + "static/media/html-css-javascript.2c7701aa.jpg";